export default "__VITE_ASSET__cf944b98__"